import React, { useEffect, useRef } from 'react';
import Box from '../../components/Box/Box';
import Icon from '../../components/Icon/Icon';
import { isEscape } from '../../utils/keyboard';

type THamburgerMenuOverlay = {
  isVisible: boolean;
  hideHamburgerMenu: () => void;
};

type TCloseHamburgerMenuProps = {
  hideHamburgerMenu: () => void;
};

export const HamburgerMenuOverlay = ({ isVisible, hideHamburgerMenu }: THamburgerMenuOverlay) => {
  if (!isVisible) return null;

  return (
    <Box
      as="div"
      role="presentation"
      onClick={hideHamburgerMenu}
      onTouchStart={(e) => e.preventDefault()}
      parent="HamburgerMenu"
      name="overlay"
      data-role="hamburgerOverlay"
    />
  );
};

export const CloseHamburgerMenu = ({ hideHamburgerMenu }: TCloseHamburgerMenuProps) => {
  const buttonRef = useRef<HTMLButtonElement | null>(null);
  const makeCloseListener = () => {
    const listener = (event: KeyboardEvent) => isEscape(event.key) && hideHamburgerMenu();

    window?.addEventListener('keydown', listener);
    return () => window?.removeEventListener('keydown', listener);
  };

  useEffect(makeCloseListener, [hideHamburgerMenu]);
  useEffect(() => {
    const _buttonRef = buttonRef?.current;
    _buttonRef?.focus();
    return () => _buttonRef?.blur();
  }, [buttonRef]);

  return (
    <Box
      as="button"
      parent="HamburgerMenu"
      name="close"
      aria-label="close hamburger menu"
      onClick={hideHamburgerMenu}
      data-role="hamburgerClose"
      ref={buttonRef}
    >
      <Icon name="close" size="m" />
    </Box>
  );
};
